<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Cancel Proposal</h5>
      <button
        type="button"
        class="btn-close"
        ref="modalCloseBtn"
        data-bs-dismiss="modal"
        aria-label="Close"
      >
        <i class="bi bi-x-circle"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="partner-modal-section">
        <p class="modal-text">
          Please select the reason behind cancellation of Proposal
        </p>
        <div class="form-group">
          <div class="form-item">
            <input
              type="radio"
              name="cancel_remark"
              v-model="cancellation_proposal"
              value="False entry"
            /><span>False entry</span>
          </div>
          <div class="form-item">
            <input
              type="radio"
              name="cancel_remark"
              v-model="cancellation_proposal"
              value="Passenger declined"
            /><span>Passenger declined</span>
          </div>
          <div class="form-item">
            <input
              type="radio"
              name="cancel_remark"
              v-model="cancellation_proposal"
              value="Low utilization"
            /><span>Low utilization</span>
          </div>
          <div class="form-item">
            <input
              type="radio"
              name="cancel_remark"
              v-model="cancellation_proposal"
              value="No vehicle found"
            /><span>No vehicle found</span>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-cancel" data-bs-dismiss="modal" aria-label="Close">
        Close
      </button>
      <button v-if="isLoading" class="btn btn-primary" type="button" disabled>
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        Loading...
      </button>
      <button v-else class="btn btn-primary" @click="cancelRequest">
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import http from '../../../config/axios';

export default {
  props: ['request'],
  data() {
    return {
      isLoading: false,
      cancellation_proposal: ''
    };
  },
  watch: {
    request() {
      this.cancellation_proposal = '';
    }
  },
  methods: {
    cancelRequest() {
      if (this.cancellation_proposal) {
        this.isLoading = true;
        http
          .patch(
            `v2/partners/triprequestroutes/${this.request.id}?trip_requests_id=${this.request.trip_requests_id}`,
            {
              status: 'Cancelled',
              cancellation_proposal: this.cancellation_proposal,
              remarks_by_partner: [this.cancellation_proposal]
            }
          )
          .then((response) => {
            this.isLoading = false;
            this.$emit('refreshData');
            this.$refs.modalCloseBtn.click();
            this.$partnerSwal.quickSuccessAlert.fire({
              title: 'Success!',
              text: response.data?.message
            });
          })
          .catch((error) => {
            this.isLoading = false;
            this.$partnerSwal.errorToast.fire({
              title: 'Error!',
              text: error.response.data?.message
            });
          });
      } else {
        this.$partnerSwal.warningToast.fire({
          title: 'Warning!',
          text: 'Please select a cancellation proposal first!'
        });
      }
    }
  }
};
</script>

<style scoped>
.modal-text {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 0;
}
.partner-modal-section {
}
.partner-modal-section .form-group {
  margin: 21px 0 5px 0;
}
.partner-modal-section .form-group .form-item {
  display: flex;
  margin-bottom: 18px;
}
.partner-modal-section .form-group .form-item input {
  margin-right: 16px;
  accent-color: #a95eea;
}
.partner-modal-section .form-group .form-item span {
  font-size: 14px;
  font-weight: 500;
}
.partner-modal-section .form-group .form-item:last-child {
  margin-bottom: 0;
}
</style>
